module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAOCAYAAAASVl2WAAAAAXNSR0IArs4c6QAAASJJREFUGBlVj7FKxEAQhrObHIfIgYVgsAyCD3CFhSCohYignJWNTRIS7oXkIgmBYGPqA0VtBCtBn0BBOLCLiBzBkCJ+I95hBmZnJt+//2zUaDQaG4bRsyxr4Pv+B30rNNNy0zRbdV3fpGm61KIMutPpHFNfyH5VVddJkvT+i7Tnee/dbndHKfWG0wZOV1mWLc5EssJwXXcC3KaVulmW5TjP8wVhSo5ZxHG8hsM98yqOtzgftgQi5A3rIsJpBdHl74qZg1THcV4pT9Ij6rcc2GsWRXEBO+H2J7k7d0CtgalA8ot5LwzDZ4tBrFQURee0p+TUNM39IAgehZly2LZ9RgmwLIEHwAf5LqG5OaQOgd9a6yOg/OY8NGDKNCEHwLs5+Wt+AMO0cRmCKQSHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-closed.png
// module id = 347
// module chunks = 0 1 5 6 7 9 10